module.exports = __webpack_public_path__ + "static/mo00-b5f2bc64903788361786104c3d90ec53.png";